import {createTheme} from '@material-ui/core';
import {designTokens} from '../styles/designTokens';

const themeMaterialUI = createTheme({
  shape: {
    borderRadius: '25px',
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: designTokens.borderRadius.button,
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: '0.875rem',
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: designTokens.borderRadius.input,
        backgroundColor: designTokens.colors.white,
        '&:hover $notchedOutline': {
          borderColor: designTokens.colors.primary,
        },
        '&$focused $notchedOutline': {
          borderColor: designTokens.colors.primary,
          borderWidth: '1px',
        },
      },
      notchedOutline: {
        borderColor: '#D5D7DA',
        borderWidth: '1px',
      },
      input: {
        height: '24px',
        padding: '10px 14px',
        boxSizing: 'content-box',
        fontFamily: designTokens.fontFamily,
        fontSize: designTokens.typography.placeholder.fontSize,
        fontWeight: designTokens.typography.placeholder.fontWeight,
        lineHeight: designTokens.typography.placeholder.lineHeight,
        color: designTokens.colors.text.primary,
        '&::placeholder': {
          color: designTokens.typography.placeholder.color,
          opacity: 1,
        },
      },
    },
  },
  palette: {
    primary:  {
      main: '#0077c888',
      dark: '#1a4767',
      light: '#f7fcff',
      50: '#0077c8',
      100: '#7ccaff',
      item: '#0077c85e',
      cell: '#0077c899',
    },
    secondary: {
      main: '#e4002b88',
    },
    error: {
      main: '#A02929',
      light: '#e41e15',
    },
    header: {
      main: designTokens.colors.background.nav.main,
    },
    star: {
      color: '#ffb400',
    },
  },
});

export default themeMaterialUI;
